<template>
  <div class="w-full text-black">
    <div id="BookedLessons" class="text-left w-full rounded-lg p-6 my-16
    border-chocolate-academy-600 bg-beige-academy-100"
    v-if="slots.length>0" >
      <h3 class="font-bold text-2xl pb-1 pl-2 mb-4 border-b-2 border-chocolate-academy-600
        w-full md:w-3/5">
          {{ title }}</h3>
      <div v-for="slot in slots" :key="slot.id" v-show="slots.indexOf(slot)<=number"
        class="flex py-2 text-xl items-center">
        <button @click="loadDashboard(slot)" class="font-black text-chocolate-academy-600 pl-4
            transform duration-500 hover:scale-100 hover:-translate-y-1 w-1/4 text-left text-xl">
          {{ isStudent ? slot.teacher_name : slot.student_name}}
        </button>
        <div class="flex text-center w-1/3">
          <span class="mr-10">{{slot.day}}</span>
          <span>{{slot.timeStart}}-{{slot.timeEnd}}</span>
        </div>

        <span v-if="slot.lesson" class="w-1/4 text-center">
          {{ formatter.format(slot.lesson.total_to_pay/100) }}
        </span>

        <div class="w-1/3 pr-5">
          <button class="rounded border border-orange-academy-300 text-orange-academy-300 bg-white
            p-2 mx-4 transform duration-500 hover:scale-110 hover:-translate-y-1 text-sm w-full"
            @click="$emit('startLesson', slot)" v-if="!slot.lesson || slot.lesson.started">
              {{ $t('bookedLessonsDashboard.startLesson') }}
          </button>
        </div>

      </div>
    </div>
    <div class="flex justify-center w-1/4" v-if="slots.length>5">
      <dashboard-button
        v-if="!all"
        @click="number=slots.length;all=true"
        :buttonPlaceholder="$t('bookedLessonsDashboard.see')"
        class="mt-4 md:mt-0 self-center" />
      <dashboard-button
        v-else
        @click="number=5;all=false"
        :buttonPlaceholder="$t('bookedLessonsDashboard.reduce')"
        class="mt-4 md:mt-0 self-center" />
    </div>
  </div>
</template>

<script>
import DashboardButton from '@/components/DashboardButton.vue';
import { mapGetters } from 'vuex';

export default {
  props: ['title', 'slots', 'isStudent'],

  components: {
    DashboardButton,
  },

  data() {
    return {
      number: 5,
      all: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  methods: {
    async loadDashboard(slot) {
      if (this.isStudent) {
        this.$router.replace({ path: `/teacher/${slot.teacher_id}` });
        return;
      }
      this.$router.replace({ path: `/student/${slot.student_id}` });
    },
  },
};
</script>
